<template>
  <f7-row class="wd-100">
    <f7-col width="65">
      <div
        class="wd-100 h-135"
        :style="`background-image: url('//madai.mx/assets/images/${itm.image}'); background-position: center; background-repeat: no-repeat; background-size: cover;`" />
        <!-- <div
        class="wd-100 h-135"
        :style="`background-image: url('//imgur.com/IeAlvKP.png'); background-position: center; background-repeat: no-repeat; background-size: cover;`" /> -->
    </f7-col>
    <f7-col width="35">
      <span class="shopping-icon float-right">
        <template v-if="itm.addToCart || storage.carrito.find(item => item.cve === itm.cve)">
          <f7-link @click="agregarCarrito(itm)">
            <f7-icon class="add_shopping_cart" :md="storage.carrito.find(item => item.cve === itm.cve) ? 'material:remove_shopping_cart' : 'material:add_shopping_cart'"></f7-icon>
          </f7-link>
        </template>
        <template v-else>
          <f7-link :href="`/cadenas/${itm.id_chain}/`" @click="seleccionMedidaAviso()">
            <f7-icon class="add_shopping_cart" :md="storage.carrito.find(item => item.cve === itm.cve) ? 'material:remove_shopping_cart' : 'material:add_shopping_cart'"></f7-icon>
          </f7-link>
        </template>
      </span>
      <span class="d-block text-uppercase bold text-dark m-t-5">{{ itm.cve }}</span>
      <span class="favorite-icon">
        <f7-link
          @click="storage.wishlist.find(item => item.cve === itm.cve) === undefined ?
            storage.wishlist.push(itm) :
            storage.wishlist = storage.wishlist.filter(item => item.cve !== itm.cve)"
          >
          <f7-icon class="favorite-color" :md="storage.wishlist.find(item => item.cve === itm.cve) ? 'material:favorite' : 'material:favorite_border'"></f7-icon>
        </f7-link>
      </span>
      <span class="d-block text-uppercase fs-10 bold">{{ itm.type }}</span>
        <!-- $helper.str.capitalizar(itm.description) + ' ' + -->
      <span class="d-block fs-13 m-t-5">
        {{ $helper.str.capitalizar(itm.material) + ' ' + itm.specification + 'k, ' + itm.length + ' cm de largo y ' + itm.width + ' mm de ancho.' }}
      </span>
      <div class="m-t-5">
        <span class="bold text-color-madai m-r-10">{{ $helper.str.formatearMoneda(itm.price) }}</span>
        <span class="fs-10 d-block">IVA INCLUIDO</span>
      </div>
      <span class="carrito-icon" :class="{ hide: !storage.carrito.find(item => item.cve === itm.cve) }">
        <f7-icon md="material:shopping_basket"></f7-icon>
      </span>
    </f7-col>
  </f7-row>
</template>

<script>
export default {
  props: ['itm'],
  methods: {
    agregarCarrito (itm) {
      if (this.storage.carrito.find(item => item.cve === itm.cve)) {
        this.storage.carrito = this.storage.carrito.filter(item => item.cve !== itm.cve)
      } else {
        this.storage.carrito.push(itm)
      }
    },
    seleccionMedidaAviso () {
      this.$f7.dialog.create({
        destroyOnClose: true,
        text: 'Selecciona un tamaño y a continuación haz clic en "AGREGAR A CARRITO"',
        buttons: [
          {
            text: 'Aceptar'
          }
        ]
      }).open()
    }
  }
}
</script>
